export const LOADING_LABEL = ', Loading';